import React from "react";
import { useState } from "react";
import { Link } from 'react-router-dom';
import { GetSignStatus, GetApproveStatus } from './Order';

import SearchBar from "./common/SearchBar";


function Order({id, year, user, date_created, approve_status, sign_status, user_docs, multiple_positions}){

  let approveStatusDisplay = GetApproveStatus(approve_status);
  let signStatusDisplay = GetSignStatus(sign_status);

  return(
    <tr className="">
      <td><Link className="" to={`/order/` + id}>{year}</Link> </td>
      <td>{user.username}</td>
      <td>{date_created}</td>
      <td>{approve_status=== "APPROVED" ? 
          <span className="text-success fw-semibold">{approveStatusDisplay}</span> 
        : 
          approve_status=== "REJECTED" ? 
            <span className="text-danger fw-semibold">{approveStatusDisplay}</span> 
          : 
            <span  className="">{approveStatusDisplay}</span>
          }
      </td>

      <td>{user_docs ? <span className="text-primary">Да</span> : <span>Нет</span>}</td>

      {sign_status === "NOT_SIGNED" && <td><span className="">{signStatusDisplay}</span></td>}
      {sign_status === "SELLER_SIGNED" && <td><span className="text-success">{signStatusDisplay}</span></td> }
      {sign_status === "CLIENT_SIGNED" && <td><span className="text-success">{signStatusDisplay}</span></td> }
      {sign_status === "BOTH_SIGNED" && <td><span className="text-success fw-semibold">{signStatusDisplay}</span></td> }

      <td>{multiple_positions ? <span className="text-primary">Да</span> : <span>Нет</span>}</td>
    </tr>
  )

}


export default function OrderList({orders}) {
  const [searchText, setSearchText] = useState('');

  let rows = [];
  for(let i in orders) {
    console.log(orders[i])
    if (orders[i].user.username.toLowerCase().indexOf(searchText.toLowerCase()) === -1) {
      //pass
    } else {

      rows.push(
        <Order
          key={orders[i].id}
          id={orders[i].id}  
          year={orders[i].year}
          user={orders[i].user}
          date_created={orders[i].date_created}
          approve_status={orders[i].approve_status}
          user_docs={(orders[i].user_signed_contract_pdf && orders[i].user_signed_order_form_pdf)}
          sign_status={orders[i].sign_status} 
          multiple_positions={orders[i].multiple_positions}  
        />
      );
    }
  }

  return(
    <>
      <div className="row">
       <h3 className="m-3">Заказы и Договоры</h3>
      </div>
      <div className="m-3">
        <SearchBar
          key="SearchBar" 
          searchText={searchText} 
          onSearchtextChange={setSearchText} 
        />
      </div>
      <div className="row m-3">
        <table className="table">
          <thead>
            <tr>
              <th>год договора</th>   
              <th>лаборатория</th>
              <th>создан</th>        
              <th>статус утверждения</th> 
              <th>документы пользователя</th> 
              <th>статус подписания</th>
              <th>множественные позиции</th>      
            </tr>
          </thead>
          <tbody>
            {rows} 
          </tbody>
        </table>
      </div>

      {/* <div>
        <SearchBar
          key = "SearchBar" 
          searchText={searchText} 
          onSearchtextChange={setSearchText} 
        />
      </div> */}

    </>
  );
}
